module.exports = __webpack_public_path__ + "img/img_throw_3@3x.30679b60.png";